import React from 'react';

export default function TriangleExclamation({ iconClass }: { iconClass?: string }) {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="M347.4 97.9 565.7 496l26.3 48H48l26.3-48L292.6 97.9 320 48zM129.1 496h381.8L320 147.8zM348 460h-56v-56h56zm-8.8-84h-38.4L288 256h64z" />
    </svg>
  )
}
